import { Loader } from '@/components/loaders/loader';
import { TableBodyWrapper, TableWrapper } from '@/components/table/styles';
import TableHeader from '@/components/table/tableHeader';
import { IItems, ISort } from '@/components/table/types';
import { useResponsive } from '@/hooks/use-responsive';
import { firmTableColumns } from '../constants';
import { IUser } from '../types';
import MobileTable from './mobileTable';
import TableBody from './tableBody';

interface FirmTableTableProps {
  firmTableTableData: IUser[];
  sort: ISort;
  loading: boolean;
  flashUpdatingRow: string;
  setSort: (value: ISort) => void;
  actionsByStatus: (row: IUser) => IItems[];
}

const FirmTable = ({ sort, loading, firmTableTableData, flashUpdatingRow, setSort, actionsByStatus }: FirmTableTableProps) => {
  const { isMobile } = useResponsive();

  return (
    <TableWrapper padding="0">
      {isMobile ? (
        <>
          {loading ? (
            <Loader />
          ) : (
            <MobileTable firmTableTableData={firmTableTableData} flashUpdatingRow={flashUpdatingRow} actionsByStatus={actionsByStatus} />
          )}
        </>
      ) : (
        <>
          <TableHeader refetch={() => {}} columns={firmTableColumns} savedSort={sort} savedSetSort={setSort} />
          <TableBodyWrapper>
            {loading ? (
              <Loader />
            ) : (
              <TableBody firmTableTableData={firmTableTableData} flashUpdatingRow={flashUpdatingRow} actionsByStatus={actionsByStatus} />
            )}
          </TableBodyWrapper>
        </>
      )}
    </TableWrapper>
  );
};

export default FirmTable;
